export default "/icons/html5.svg";